// src/api/index.js
import axios from "axios";

const HOST = typeof window !== "undefined" ? window.location.hostname : "";
const PRO = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "pro";

function getServerUrl() {
  // Dev local
  if (!PRO || HOST === "localhost" || HOST === "127.0.0.1") {
    return "http://localhost:4001";
  }

  // Producción (oncommit)
  if (HOST.endsWith("df.owius.com")) {
    return "https://cobega-api.evenely.com";
  }

  // Producción (onconext)
  if (HOST.endsWith("df.owius.com")) {
    return "https://cobega-api.evenely.com";
  }

  // Servidor “backup” (owius)
  if (HOST.endsWith("owius.com")) {
    return "https://cobega-api.evenely.com";
  }

  // Fallback (por si se añade otro subdominio)
  return "https://cobega-api.evenely.com";
}

export const SERVER_URL = getServerUrl();
export const API = `${SERVER_URL}/api`;

export const baseClient = () =>
  axios.create({ baseURL: API });

export const authClient = () =>
  axios.create({ baseURL: API, withCredentials: true });
